import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './UnderwritingComponent.metadata.json5';
import styles from '../LifeAgents.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function UnderwritingComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('UnderwritingComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        reaForCanOrRef2: {
            visible: !_.isUndefined(modelVM.hasTheAppSEveHadIns1.value) && modelVM.hasTheAppSEveHadIns1.value === true
        },
        ifYesPleDes4: {
            visible: !_.isUndefined(modelVM.areYouOrYouComParDir3.value) && modelVM.areYouOrYouComParDir3.value === true
        },
        ifYesPleDes6: {
            visible: !_.isUndefined(modelVM.areYouOrYouComParDir5.value) && modelVM.areYouOrYouComParDir5.value === true
        },
        ifYesPleDes8: {
            visible: !_.isUndefined(modelVM.isTheAppSAwaOfAny7.value) && modelVM.isTheAppSAwaOfAny7.value === true
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

UnderwritingComponent.propTypes = wizardProps;
export default withRouter(UnderwritingComponent);
